<app-header
  canvasMode="cms"
  [loggedIn]="true"
  [fixedHeader]="true"
></app-header>

<div class="home-container" style="height: 90vh">
  <h1 class="welcome-message">Content Management System Dashboard</h1>
  <div class="description">
    <span>Disclaimer: DO NOT MODIFY ANYTHING ON THIS PAGE. </span>The CMS has
    the potential to impact all customers. If you have questions regarding any
    information on this page, please contact the Product team.
  </div>

  <div class="home-container" style="margin-top: 20px">
    <app-cms-list [toggleRefresh]="toggleRefresh"></app-cms-list>
  </div>
</div>
